'use client';

import type { ReactNode } from 'react';
import { cx } from 'class-variance-authority';
import { mergeProps } from 'react-aria';
import { XMarkIcon } from '@cbhq/bds-web/icons/2.5/x-mark-icon';
import { Button } from '@redesign/components/dashboard/shared/button/button';
import type { ButtonContextType } from '@redesign/utils/logging';

export type GlobalBannerProps = React.ComponentProps<'div'> & {
  children: ReactNode;
  onDismiss: () => void;
  dismissLogContext: ButtonContextType;
};

/** Full-width announcement strip displayed above the page content. */
export function GlobalBanner({
  children,
  onDismiss,
  dismissLogContext,
  ...props
}: GlobalBannerProps) {
  return (
    <div
      {...mergeProps(props, {
        role: 'region',
        'aria-label': 'Announcement',
        className: cx(
          'relative flex min-h-9 w-full items-center justify-center bg-bds-gray-5 px-12 py-1.5 text-center text-label-regular text-bds-gray-90',
          props.className
        ),
      })}
    >
      <p>{children}</p>
      <Button
        logContext={dismissLogContext}
        variant="bare"
        size="sm"
        aria-label="Dismiss announcement"
        className="absolute right-4 top-1/2 -translate-y-1/2 text-bds-gray-50"
        onPress={onDismiss}
      >
        <XMarkIcon className="size-4" />
      </Button>
    </div>
  );
}
